<template>
    <div class="main-nav">
        <div class="section-head">
            <span class="section-title">应用分区</span>
            <span class="section-tag">BETA 频道</span>
        </div>
        <div class="classify-row">
            <button
                v-for="item in classArr"
                :key="item.id"
                type="button"
                class="class-chip"
                :class="{ active: activeClassify === item.classify }"
                @click="switchClass(item)"
            >
                {{ item.classify }}
            </button>
        </div>

        <div class="app-icon-grid">
            <button
                v-for="item in dataList"
                :key="item.id"
                type="button"
                class="app-icon-btn"
                @click="toPath(item)">
                <img class="item-image" :src="item.pic" alt="" />
                <span class="item-title">{{ item.title }}</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            classArr: [
                { id: 1, classify: "分类1" },
                { id: 2, classify: "分类2" },
                { id: 3, classify: "分类3" },
            ],
            dataList: [],
            activeClassify: ''
        }
    },
    methods: {
        // 获取分类
        async getSet() {
            const { data: res } = await this.$http.get('/classify')
            this.classArr = res.data || []
            const first = this.classArr[0]
            if (first && first.classify) {
                this.switchClass(first)
            }
        },
        // 获取对应分类的应用
        async getListClass(title) {
            const { data: res } = await this.$http.get('/list_class',{
                params: {class: title}
            })
            this.dataList = res.data
        },
        switchClass(item) {
            const title = item && item.classify ? item.classify : ''
            if (!title) return
            this.activeClassify = title
            this.getListClass(title)
        },
        // 直接跳转到应用下载链接并上报点击统计
        async toPath(itemInfo) {
            if (!itemInfo || !itemInfo.url) return

            try {
                await this.$http.post('/track_click', {
                    target_type: 'app',
                    target_id: itemInfo.id
                })
            } catch (error) {
                // 统计失败不阻断下载跳转
            }

            window.open(itemInfo.url, '_blank')
        }
    },
    created() {
        this.getSet()
    }
}
</script>

<style lang="less" scoped>
.main-nav {
    border-radius: var(--a-radius);
    padding: .72rem;
    background: linear-gradient(145deg, rgba(15, 23, 42, 0.95), rgba(9, 14, 34, 0.92));
    border: 1px solid rgba(34, 211, 238, 0.16);
    box-shadow: var(--a-shadow);
    overflow: hidden;
}

.section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: .35rem;
}

.section-title {
    font-size: 1.05rem;
    font-weight: 800;
    color: #f8fafc;
}

.section-tag {
    font-size: .75rem;
    color: #020617;
    background: linear-gradient(120deg, #8b5cf6, #22d3ee);
    border-radius: 999px;
    padding: .2rem .6rem;
}

.classify-row {
    display: flex;
    gap: .35rem;
    overflow-x: auto;
    padding-bottom: .35rem;
    margin-bottom: .45rem;
    scrollbar-width: none;
}

.classify-row::-webkit-scrollbar {
    display: none;
}

.class-chip {
    flex-shrink: 0;
    border: 1px solid rgba(255,255,255,.08);
    background: rgba(255,255,255,.04);
    color: #cbd5e1;
    padding: .3rem .68rem;
    border-radius: 999px;
    font-size: .8rem;
    font-weight: 700;
    transition: all .2s ease;
}

.class-chip.active {
    background: linear-gradient(120deg, #8b5cf6, #22d3ee);
    color: #020617;
    border-color: transparent;
}

.app-icon-grid {
    margin-top: .1rem;
    display: flex;
    flex-wrap: wrap;
    gap: .14rem;
    width: 100%;
}

.app-icon-btn {
    width: calc((100% - .7rem) / 6);
    border: 0;
    background: transparent;
    padding: 0;
    min-width: 0;
    flex: 0 0 calc((100% - .7rem) / 6);
}

.item-image {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 1 / 1;
    border-radius: .48rem;
    border: 1px solid rgba(34, 211, 238, .16);
    box-shadow: 0 10px 18px rgba(2, 6, 23, .28);
    object-fit: cover;
    transition: all .35s;
}

.item-title {
    color: #e2e8f0;
    display: block;
    font-size: .68rem;
    font-weight: 700;
    line-height: 1.15;
    margin-top: .14rem;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

@media screen and (max-width: 360px) {
    .main-nav {
        padding: .62rem;
    }
    .app-icon-grid {
        gap: .12rem;
    }
    .app-icon-btn {
        width: calc((100% - .48rem) / 5);
        flex: 0 0 calc((100% - .48rem) / 5);
    }
}

@media screen and (max-width: 330px) {
    .app-icon-grid {
        gap: .1rem;
    }
    .app-icon-btn {
        width: calc((100% - .3rem) / 4);
        flex: 0 0 calc((100% - .3rem) / 4);
    }
}
</style>